module.exports = __webpack_public_path__ + "img/PK_Info_Game4.b618c5ee.png";